// Old browsers

import supportedBrowsers from "./vendor/supportedBrowsers";

const ua = navigator.userAgent;
const bot = /bot|googlebot|crawler|spider|robot|crawling/i.test(ua);
const supported = supportedBrowsers.test(ua);

if (!bot && !supported) {
  const body = document.body;
  const innerHTML = body.innerHTML;
  body.innerHTML = `
    <div class="unsupported">
      <div class"container">
        Sorry, your browser isn't supported, so things may look a little weird.
        You should probably <a href="https://browsehappy.com" target="_blank" rel="noopener">upgrade</a> it.
      </div>
    </div>
    ${innerHTML}
  `;
}

if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

// Stimulus

import { Application } from "stimulus";
import { definitionsFromContext } from "stimulus/webpack-helpers";

const application = Application.start();
const context = require.context("./controllers", true, /\.js$/);
application.load(definitionsFromContext(context));

// Disable animations on initial page load

setTimeout(() => {
  document.querySelector("html").classList.remove("is-loading");
}, 500);
